/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: PZbWryjVVD

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_plasmic_kit_data_binding.module.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicDataPickerSelectedItem.module.css"; // plasmic-import: PZbWryjVVD/css

createPlasmicElementProxy;

export type PlasmicDataPickerSelectedItem__VariantMembers = {
  lastItem: "lastItem";
};
export type PlasmicDataPickerSelectedItem__VariantsArgs = {
  lastItem?: SingleBooleanChoiceArg<"lastItem">;
};
type VariantPropType = keyof PlasmicDataPickerSelectedItem__VariantsArgs;
export const PlasmicDataPickerSelectedItem__VariantProps =
  new Array<VariantPropType>("lastItem");

export type PlasmicDataPickerSelectedItem__ArgsType = {};
type ArgPropType = keyof PlasmicDataPickerSelectedItem__ArgsType;
export const PlasmicDataPickerSelectedItem__ArgProps = new Array<ArgPropType>();

export type PlasmicDataPickerSelectedItem__OverridesType = {
  root?: Flex__<"div">;
  itemName?: Flex__<"div">;
  slash?: Flex__<"div">;
};

export interface DefaultDataPickerSelectedItemProps {
  lastItem?: SingleBooleanChoiceArg<"lastItem">;
  className?: string;
}

const $$ = {};

function PlasmicDataPickerSelectedItem__RenderFunc(props: {
  variants: PlasmicDataPickerSelectedItem__VariantsArgs;
  args: PlasmicDataPickerSelectedItem__ArgsType;
  overrides: PlasmicDataPickerSelectedItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "lastItem",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.lastItem,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootlastItem]: hasVariant($state, "lastItem", "lastItem") }
      )}
    >
      <div
        data-plasmic-name={"itemName"}
        data-plasmic-override={overrides.itemName}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.itemName,
          { [sty.itemNamelastItem]: hasVariant($state, "lastItem", "lastItem") }
        )}
      >
        {"Current"}
      </div>
      <div
        data-plasmic-name={"slash"}
        data-plasmic-override={overrides.slash}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.slash,
          { [sty.slashlastItem]: hasVariant($state, "lastItem", "lastItem") }
        )}
      >
        {"/"}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "itemName", "slash"],
  itemName: ["itemName"],
  slash: ["slash"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  itemName: "div";
  slash: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDataPickerSelectedItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDataPickerSelectedItem__VariantsArgs;
    args?: PlasmicDataPickerSelectedItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicDataPickerSelectedItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDataPickerSelectedItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDataPickerSelectedItem__ArgProps,
          internalVariantPropNames: PlasmicDataPickerSelectedItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDataPickerSelectedItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDataPickerSelectedItem";
  } else {
    func.displayName = `PlasmicDataPickerSelectedItem.${nodeName}`;
  }
  return func;
}

export const PlasmicDataPickerSelectedItem = Object.assign(
  // Top-level PlasmicDataPickerSelectedItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    itemName: makeNodeComponent("itemName"),
    slash: makeNodeComponent("slash"),

    // Metadata about props expected for PlasmicDataPickerSelectedItem
    internalVariantProps: PlasmicDataPickerSelectedItem__VariantProps,
    internalArgProps: PlasmicDataPickerSelectedItem__ArgProps,
  }
);

export default PlasmicDataPickerSelectedItem;
/* prettier-ignore-end */
